import React from 'react'
import { connect } from 'react-redux'
import { deleteNotification } from '../../../../../action/notification-actions'
import './index.scss'
import { dateConvertion } from '../../../../../component/main-ui/common/commonfunctions'

const NotificationItem = props => {
  const { notifications, entry, deleteNotification } = props,
    date = new Date(entry.sent)

  let dateShow = dateConvertion(entry.sent)
  return (
    <div className='notification-entry'>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <p>
          {dateShow}
        </p>
        <div className='notification-close' onClick={() => {
          deleteNotification(entry.id)
        }}></div>
      </div>
      <p>
        {entry.body}
      </p>
    </div>
  )
}

const mapStateToProps = state => ({
  notifications: state.notifications
})

const mapDispatchToProps = dispatch => ({
  deleteNotification: id => dispatch(deleteNotification(id))
})

export default connect(mapStateToProps, mapDispatchToProps)(NotificationItem)